export default __webpack_public_path__ + "assets/iphone.0b6dbb19.svg";